<template>
  <div class="comment-list">
    <p v-if="!comments.length" class="empty-state">Комментариев пока нет</p>

    <article v-for="comment in comments" :key="comment.id" class="comment-item">
      <header class="comment-header">
        <AuthorLink :author="comment.author" size="sm" class="comment-author" />
        <span class="comment-date">{{ formatDate(comment.created_at) }}</span>
      </header>

      <p v-if="comment.body" class="comment-body">{{ comment.body }}</p>

      <p v-if="comment.lat && comment.lng" class="comment-location">
        Точка на карте: {{ comment.lat }}, {{ comment.lng }}
      </p>

      <PhotoSlider
        v-if="comment.photos?.length"
        :photos="comment.photos"
        compact
        :delegate-open="delegateGallery"
        class="comment-photos"
        @open="(index) => $emit('open-gallery', comment, index)"
      />

      <button
        v-if="canDelete(comment)"
        type="button"
        class="btn btn-secondary comment-delete"
        :disabled="deletingId === comment.id"
        @click="$emit('delete', comment)"
      >
        {{ deletingId === comment.id ? 'Удаление...' : 'Удалить' }}
      </button>

      <ReactionBar
        v-if="interactive"
        class="comment-reactions"
        compact
        :likes-count="comment.likes_count ?? 0"
        :dislikes-count="comment.dislikes_count ?? 0"
        :user-reaction="comment.user_reaction"
        :disabled="reactingId === comment.id"
        @react="(value) => $emit('react', comment, value)"
        @unreact="$emit('unreact', comment)"
      />
    </article>
  </div>
</template>

<script setup>
import PhotoSlider from './PhotoSlider.vue'
import ReactionBar from './ReactionBar.vue'
import AuthorLink from './AuthorLink.vue'

defineProps({
  comments: {
    type: Array,
    default: () => [],
  },
  interactive: {
    type: Boolean,
    default: true,
  },
  canDelete: {
    type: Function,
    required: true,
  },
  deletingId: {
    type: [Number, null],
    default: null,
  },
  reactingId: {
    type: [Number, null],
    default: null,
  },
  delegateGallery: {
    type: Boolean,
    default: false,
  },
})

defineEmits(['delete', 'open-gallery', 'react', 'unreact'])

function formatDate(value) {
  if (!value) return ''
  return new Date(value).toLocaleString('ru-RU')
}
</script>

<style scoped>
.comment-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.comment-item {
  border: 1px solid #e2e8f0;
  border-radius: 0.75rem;
  padding: 0.75rem;
  background: #fff;
}

.comment-header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.125rem;
  font-size: 0.875rem;
  margin-bottom: 0.5rem;
}

.comment-author {
  font-weight: 600;
}

.comment-date {
  font-size: 0.75rem;
  color: #64748b;
  line-height: 1.3;
}

.comment-body {
  margin: 0 0 0.5rem;
  white-space: pre-wrap;
}

.comment-location {
  margin: 0 0 0.5rem;
  font-size: 0.875rem;
  color: #64748b;
}

.comment-photos {
  margin-bottom: 0.5rem;
}

.comment-delete {
  font-size: 0.875rem;
  padding: 0.375rem 0.75rem;
}

.comment-reactions {
  margin-top: 0.5rem;
}
</style>
